<template>
  <div>
    <b-modal id="form-master-transport" size="lg" no-close-on-backdrop :title="(editId == null ? 'Tambah' : 'Edit') + ' ' + pageTitle" >
        <validation-observer ref="masterTransport">
            <form>
                <horizontal-form-group label="Grade">
                  <validation-provider #default="{ errors }" name="name" rules="required">
                    <v-select size="sm" v-model="formPayload.grade" :options="dataGrade" label="text">

                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </horizontal-form-group>

                <horizontal-form-group label="Nominal">
                  <validation-provider #default="{ errors }" name="nominal" rules="required">
                    <b-form-input placeholder="Rp." v-model="formPayload.nominal" type="number"></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </horizontal-form-group>
            </form>
        </validation-observer>
        <template #modal-footer="{}">
          <b-button class="d-flex" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" :disabled="loading" @click="submitItem()">
            <b-spinner small variant="light" class="mr-1" v-if="loading" /> Simpan
          </b-button>
        </template>
    </b-modal>
  </div>
</template>

<script>
import InputText from "@/components/InputText.vue";
import InputTextArea from "@/components/InputTextArea.vue";
import InputFile from "@/components/InputFile.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BFormInput,
  BButton,
  BSpinner
} from "bootstrap-vue";
import { required } from "@validations";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
export default {
  data() {
    return {
      dataGrade: []
    }
  },
  components: {
    InputText,
    InputTextArea,
    InputFile,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    required,
    BButton,
    vSelect,
    BSpinner
  },
  watch: {
    formPayload: {
      handler(value) {
        this.formPayloadAnnouncement = value;
        if (this.editId == null) {
          // this.formPayloadAnnouncement.file = value.image;
        }
      },
      deep: true,
    },
    formPayloadAnnouncement: {
      handler(value) {
        this.$emit("formPayloadAnnouncement", value);
      },
      deep: true,
    },
  },
  directives: {
    Ripple,
  },
  props: {
    pageTitle: {
      type: String,
    },
    editId: {
      type: Number,
    },
    loading: {
      type: Boolean,
    },
    formPayload: {
      type: "",
    },
    createItem: {
      type: Function,
    },
    updateItem: {
      type: Function,
    },
  },
  methods: {
    submitItem() {
      this.$refs.masterTransport.validate()
        .then((result) => {
          if (result) {
            if (this.editId == null) {
              return this.createItem();
            }
            return this.updateItem();
          }
        });
    },
    GetAllGrade() {
      this.dataGrade    =   [];
      this.$http.get('/mastering/grade/findAll')
        .then((result) => {
          for (let i = 0; i < result.data.data.content.length; i++) {
            this.dataGrade.push({
              text:  result.data.data.content[i].gradeName,
              value: result.data.data.content[i]
            });
          }
        });
    }
  },
  mounted() {
    this.GetAllGrade();
  }
}
</script>
<style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss";
</style>
